<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训通信管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-input v-model="formInline.training_name" clearable :placeholder="`请输入所属${$store.state.themeTitle}室`"></el-input>
        </el-form-item> -->
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_name" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择学年学期">
            <el-option v-for="(item,index) in $store.state.termms" :key="index" :label="item.term" :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实训过程名称">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入实训过程名称"></el-input>
        </el-form-item>
        <el-form-item label="指导教师">
          <el-select v-model="formInline.teacher" style="width:216px;" clearable filterable :loading="loading" remote :remote-method="remoteMethod" placeholder="请选择指导教师">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="course_name" label="实训过程名称" width="180">
        </custom-table-column>
        <custom-table-column  prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导教师" width="120">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="160">
        </custom-table-column>
        <custom-table-column prop="week" label="周次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="sector" label="节次" width="100">
        </custom-table-column>
        <!-- <custom-table-column prop="serial_number" label="编号" width="180">
        </custom-table-column> -->
        <custom-table-column label="状态"  prop="status" width="150" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级名称" width="180">
        </custom-table-column>
        <custom-table-column prop="item_num" label="项目数" width="100">
        </custom-table-column>
        <!-- <custom-table-column prop="phone" label="预约电话" width="135">
        </custom-table-column> -->
        <custom-table-column prop="people_number" label="人数" width="100">
        </custom-table-column>
        <!-- <custom-table-column prop="instrument" label="仪器及数量" width="120">
        </custom-table-column> -->
        <!-- <custom-table-column prop="lesson_time" label="开始时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.lesson_time? $until.getTimeStr(new Date(scope.row.lesson_time).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="lesson_end_time" label="结束时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.lesson_end_time? $until.getTimeStr(new Date(scope.row.lesson_end_time).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column> -->
        <custom-table-column prop="class_hour" label="上课学时数（小时）" width="140">
        </custom-table-column>
        <custom-table-column prop="class_content" label="实训过程内容" min-width="220" show-overflow-tooltip>
        </custom-table-column>
        <!-- <custom-table-column prop="comment" label="备注" min-width="220" show-overflow-tooltip>
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <OrganDialog ref="organDia" @getSelect="getSelect" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <!-- <el-form-item label="序  号" prop="serial_number">
          <el-input v-model="ruleForm.serial_number" placeholder="请输入编号" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="实训过程名称" prop="course_name">
          <el-input v-model="ruleForm.course_name" placeholder="请输入实训过程名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组织结构" prop="class_name">
          <el-input v-model="selectName" placeholder="请选择组织结构" style="width:532px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="学  期" prop="term">
          <el-input v-model="ruleForm.term" placeholder="请输入学年学期" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="学年学期" prop="term">
          <!-- <el-input v-model="ruleForm.term" placeholder="请输入学年学期" style="width:216px;"></el-input> -->

          <el-select v-model="ruleForm.term" clearable filterable placeholder="请选择学年学期">
            <el-option v-for="(item,index) in $store.state.termms" :key="index" :label="item.term" :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周  次" prop="week">
          <el-input v-model="ruleForm.week" placeholder="请输入周次（格式1,3,4-7）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="节  次" prop="sector">
          <el-input v-model="ruleForm.sector" placeholder="请输入节次（格式1-3）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="星  期" prop="xq">
          <el-select v-model="ruleForm.xq" clearable placeholder="请选择星期" style="width:216px;">
            <el-option v-for="item in $store.state.weeks" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项 目 数" prop="item_num">
          <el-input v-model.number="ruleForm.item_num" placeholder="请输入项目数" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="班级名称" prop="class_name">
          <el-input v-model="ruleForm.class_name" placeholder="请输入班级名称" style="width:216px;"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="开始时间" required style="width:568px"> -->
        <!-- <el-col :span="11"> -->
        <!-- <el-form-item label="开始时间" prop="lesson_time">
          <el-date-picker type="datetime" placeholder="选择开始时间" v-model="ruleForm.lesson_time" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="lesson_end_time">
          <el-date-picker type="datetime" placeholder="选择结束时间" v-model="ruleForm.lesson_end_time" style="width:216px;"></el-date-picker>
        </el-form-item> -->
        <el-form-item label="上课学时数" prop="class_hour">
          <el-input v-model="ruleForm.class_hour" placeholder="请输入上课学时数" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="仪器及数量" prop="instrument">
          <el-input type="textarea" v-model="ruleForm.instrument" style="width:532px;"></el-input>
        </el-form-item> -->
        <el-form-item label="指导教师" prop="teacher">
          <!-- <el-input v-model="ruleForm.teacher" placeholder="请输入指导教师" style="width:216px;"></el-input> -->
          <el-select v-model="ruleForm.teacher" style="width:216px;" filterable :loading="loading" remote :remote-method="remoteMethod" placeholder="请选择指导教师">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人  数" prop="people_number">
          <el-input v-model.number="ruleForm.people_number" placeholder="请输入人数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训过程内容" prop="class_content">
          <el-input type="textarea" v-model="ruleForm.class_content" style="width:532px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="备注" prop="comment">
          <el-input type="textarea" v-model="ruleForm.comment" style="width:532px;"></el-input>
        </el-form-item> -->
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan,mixinFormatter],
  data() {
    
    return {
      classRooms: [],
      
      organLabel:'',
      selectName: '',
      formInline: {
        training_name: '',
        status: '',
        structure_1: '',
        structure_2:'',
        course_name: '',
        term:'',
        teacher:''
      },
      levell: [1,2],
      loading: false,
      ruleForm: {
        term: '',
        week: '',
        sector: '',
        xq: '',
        structure_1: '',
        structure_2: '',
        class_name: '',
        course_name: '',
        people_number: 0,
        class_content: '',
        item_num: 0,
        class_hour: 0,
        teacher: '',
        lesson_time: '',
        lesson_end_time: '',
        training_name: '',
        training_no: '',
      },
      rules: {
        term: [{ required: true, message: '请输入学年学期', trigger: 'change' }],
        week: [{ required: true, message: '请输入周次（格式1,3,4-7）', trigger: 'blur' }],
        sector: [{ required: true, message: '请输入节次（格式1-3）', trigger: 'blur' }],
        // structure_1: [{ required: true, message: '请输入所属院系', trigger: 'change' }],
        class_name: [
          { required: true, message: '组织结构要选择到班级', trigger: 'change' },
          { required: true, message: '组织结构要选择到班级', trigger: 'blur' },
        ],
        // class_name: [{ required: true, message: '请输入班级名称', trigger: 'blur' }],
        course_name: [{ required: true, message: '请输入实训过程名称', trigger: 'blur' }],
        teacher: [{ required: true, message: '请选择指导教师', trigger: 'change' }],
        training_no: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        xq: [{ required: true, message: '请选择星期', trigger: 'change' }],
        people_number: [
          { required: true, message: '人数不能为空' },
          { type: 'number', message: '人数必须为数字值' },
        ],
        item_num: [
          { required: true, message: '项目数不能为空' },
          { type: 'number', message: '项目数必须为数字值' },
        ],
        // instrument: [{ required: true, message: '请输入仪器及数量', trigger: 'blur' }],
        class_hour: [{ required: true, message: '上课学时数不能为空', trigger: 'blur' }],

        class_content: [{ required: true, message: '请输入实训过程内容', trigger: 'blur' }],

        // lesson_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        // lesson_end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      users: [],
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
    

    // this.getUsers()
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    // getOrganList() {
    //   if (this.selectNode.level == 1) {
    //     this.ruleForm.structure_1 = this.selectNode.structure_names;
    //   } else {
    //     this.ruleForm.structure_1 = '';
    //   }
    //   console.log(this.ruleForm)
    //   // this.ruleForm.type_value = this.selectNode.structure_ids;
    //   // this.organs = [this.selectNode];
    // },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.structure_1 && row.structure_2 && row.class_name) {
        this.selectName = `${row.structure_1}-${row.structure_2}-${row.class_name}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    handleSign(){
      this.$message.info('签到中。。。');
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type:"1,3,7"
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    getOrganList() {
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.structure_2 = strArr[1];
        this.ruleForm.class_name = strArr[2];
      } 
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.structure_2 = '';
        this.ruleForm.class_name = '';
      }
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteCourse(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      // if (params.lesson_end_time) {
      //   let timee = params.lesson_end_time.getTime() / 1000;
      //   params.lesson_end_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.createClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let timee = '';
      // if (typeof params.lesson_time == 'string') {
      //   timee = new Date(params.lesson_time).getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // } else {
      //   timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      // if (typeof params.lesson_end_time == 'string') {
      //   timee = new Date(params.lesson_end_time).getTime() / 1000;
      //   params.lesson_end_time = this.$until.getTimeStr(timee, '-');
      // } else {
      //   timee = params.lesson_end_time.getTime() / 1000;
      //   params.lesson_end_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.update.updateClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    submitForm(formName) {
      if (this.ruleForm.lesson_time) {
        this.ruleForm.lesson_time = new Date(this.ruleForm.lesson_time);
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery1()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getClassPlanList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
